<div class="game-container"
[class.dark-background]="darkBackground"
>

  <div *ngIf="!initalMode && countdown > 0" class="countdown">
    <div class="text-stroked">{{countdown}}</div>
  </div>

  <!-- Question -->
  <div *ngIf="initalMode || !countdown" class="question">
    <div class="text-stroked" style="font-size: 1.5rem;">{{message}}</div>
  </div>

  <div *ngIf="initalMode || !countdown" class="question">
    <div *ngIf="subMessage" class="text-stroked"
         [class.fade-in-pop-slow]="subMessage"
         style="font-size: 1.3rem;"
    >{{subMessage}}</div>
  </div>

  <div #pointsAward class="points_award">
    <div class="text-stroked">{{awardMessage}}</div>
  </div>

  <div *ngIf="initalMode" class="volume-reminder" style="font-size: 1.5rem;">
    <mat-icon style="transform: scale(1.5);">volume_up</mat-icon>
    <span class="text-stroked">{{translation.guess_the_hymn.volume_up}}</span>
  </div>

  <div *ngIf="initalMode" class="options">
    <button (click)="beginClicked()" class="start-btn push-button button-green push-button-enabled">
      <mat-icon>play_arrow</mat-icon>&nbsp;
      {{translation.guess_the_hymn.begin}}
    </button>

    <button (click)="onExitImmediate()" class="start-btn push-button button-red push-button-enabled">
      <mat-icon>close</mat-icon>&nbsp;
      {{translation.guess_the_hymn.exit}}
    </button>
  </div>

  <!-- Hints -->
  <div class="options" *ngIf="showHints && !afterGame">
    <button class="after-game-option-btn push-button push-button-enabled button-blue"
            (click)="playButtonActive? playMidi() : stopMidi()">
      <mat-icon class="question-icon">{{playButtonActive? "music_note" : "volume_off"}}</mat-icon>
    </button>
    <button class="after-game-option-btn push-button"
            [class.push-button-enabled]="!hintUsedLyrics && lyricsHintsLeft > 0"
            [class.button-green]="!hintUsedLyrics && lyricsHintsLeft > 0"
            [class.push-button-disabled]="hintUsedLyrics || lyricsHintsLeft < 1"
            [disabled]="hintUsedLyrics || lyricsHintsLeft < 1"
            (click)="onHintLyrics()">
      <mat-icon>article</mat-icon>
      <span class="badge" *ngIf="lyricsHintsLeft > 0">{{ lyricsHintsLeft }}</span>
    </button>
    <button class="after-game-option-btn push-button"
            [class.push-button-enabled]="!hintUsed5050 && fiftyFiftyHintsLeft > 0"
            [class.button-purple]="!hintUsed5050 && fiftyFiftyHintsLeft > 0"
            [class.push-button-disabled]="hintUsed5050 || fiftyFiftyHintsLeft < 1"
            [disabled]="hintUsed5050 || fiftyFiftyHintsLeft < 1"
            (click)="onHint5050()">
      <mat-icon fontSet="material-icons-outlined" fontIcon="info">content_cut</mat-icon>
      <span class="badge" *ngIf="fiftyFiftyHintsLeft > 0">{{ fiftyFiftyHintsLeft }}</span>
    </button>
    <button class="after-game-option-btn push-button push-button-enabled button-red"
            (click)="onExit()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <!-- Bottom Options -->
  <div class="options">
    <button *ngFor="let option of options" class="option-btn push-button"
            [disabled]="disableOptions || option.status !== 'none'"
            [class.button-green]="option.status === 'correct'"
            [class.button-red]="option.status === 'incorrect'"
            [class.button-blue]="option.status === 'winning'"
            [class.button-dark]="option.status === 'dark'"
            [class.push-button-enabled]="option.status === 'none'"
            [class.explode-animation]="option.status === 'invisible'"
            (pointerdown)="chooseHymnOption(option)">
      {{option.hymnNumber}} - {{option.title}}
    </button>
  </div>

  <!-- Options that appear after the game is finished -->
  <div class="options" *ngIf="afterGame">
    <button class="after-game-option-btn push-button push-button-enabled button-blue"
            (click)="onInfo()">
      <mat-icon fontSet="material-icons-outlined" fontIcon="info">info</mat-icon>
    </button>
    <button class="after-game-option-btn push-button push-button-enabled button-green"
            (click)="onRestart()">
      <mat-icon>refresh</mat-icon>
    </button>
    <button class="after-game-option-btn push-button push-button-enabled button-red"
            (click)="onExitImmediate()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div *ngIf="darkOverlay" class="dark-overlay">
    <div class="dark-overlay-text">
      <div *ngIf="!countdown" class="text-stroked">{{translation.guess_the_hymn.wait_for_player}} {{3-player}}</div>
    </div>
  </div>
</div>
